// Log for test. you can delete this line anytime.
class ApiInfo {
  constructor({
    path,
    type = 'get',
    timeout = 30000,
    headers = {},
    project = 'sales-crm',
    author = '未定义',
  }) {
    this._path = path;
    this._type = type;
    this._author = author;
    this.timeout = timeout;
    this.headers = headers;
    this.project = project;
  }

  get path() {
    return this._path;
  }

  get type() {
    return this._type;
  }

  get author() {
    return this._author;
  }
}

export default ApiInfo;
